import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import "@mantine/notifications/styles.css";
import "mantine-react-table/styles.css";
import "@mantine/charts/styles.css";
import "@mantine/dropzone/styles.css";
import "@/styles/globals.css";
import * as Sentry from "@sentry/react";
import { initPromise as i18nInitPromise } from "./lib/i18n";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "@/App";
async function initializeApp() {
  await i18nInitPromise;

  if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
    //Do nothing
  } else {
    Sentry.init({
      dsn: "https://4b765c9e2cf30f0a42060f5c93d866a2@o4507372648792064.ingest.de.sentry.io/4507498247749712",
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
          maskAllText: false,
          blockAllMedia: false,
          maskAllInputs: false,
          networkDetailAllowUrls: [window.location.origin],
        }),
        Sentry.feedbackIntegration({
          showBranging: false,
          autoInject: false,
        }),
      ],
      tracesSampleRate: 0.1,
      sampleRate: 0.5,
      tracePropagationTargets: [
        "https://unitlogic.nl",
        "https://unitlogic.nl/*",
        "https://unitlogic.nl/**",
        "https://accept.unitlogic.nl",
        "https://accept.unitlogic.nl/*",
        "https://accept.unitlogic.nl/**",
        "https://white-grass-09646b903.4.azurestaticapps.net",
        "https://white-grass-09646b903.4.azurestaticapps.net/*",
        "https://white-grass-09646b903.4.azurestaticapps.net/**",
      ],
      replaysSessionSampleRate: 0.05,
      replaysOnErrorSampleRate: 1.0,
      beforeSend(event) {
        const message =
          event?.exception?.values?.[0]?.value?.toLowerCase?.() ||
          event?.message?.toLowerCase?.() ||
          "";

        // List of SignalR-related keywords
        const signalRErrors = [
          "signalr",
          "handshake was canceled",
          "server returned handshake error",
          "transport close",
          "failed to start the transport",
          "error occurred while starting connection",
          "connection disconnected with error",
        ];

        // Drop the eventSignalR-related if error keyword is found
        if (signalRErrors.some((keyword) => message.includes(keyword))) {
          return null;
        }

        return event;
      },
    });
  }
  const rootElement = document.getElementById("root");
  if (!rootElement) throw new Error("Failed to find the root element");
  const root = createRoot(rootElement);

  root.render(
    <StrictMode>
      <Sentry.ErrorBoundary fallback={<div>Something went wrong</div>}>
        <App />
      </Sentry.ErrorBoundary>
    </StrictMode>,
  );
}

initializeApp().catch(console.error);
